/* unplugin-vue-components disabled */import { render } from "./ZeroSizePlaceholder.vue?vue&type=template&id=4811dd41&scoped=true&ts=true"
import script from "./ZeroSizePlaceholder.vue?vue&type=script&lang=ts"
export * from "./ZeroSizePlaceholder.vue?vue&type=script&lang=ts"

import "./ZeroSizePlaceholder.vue?vue&type=style&index=0&id=4811dd41&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4811dd41"]])

export default __exports__